/* ONENULL v2 — finish swatches: swap image, select variant, keep the cart honest. */
(function () {
  function root(el, sel) { return el.closest(sel); }

  // SEO/speed P1: the server already renders the selected variant's image. Only swap when the
  // finish actually changes — the old on-load swap dropped srcset and re-requested the LCP hero
  // (width=800) after JS ran, which pushed Durga mobile LCP to 10.3 s.
  function swapImage(img, url, alt) {
    var pic = img.parentNode && img.parentNode.tagName === 'PICTURE' ? img.parentNode : null;
    if (pic) {
      Array.prototype.slice.call(pic.querySelectorAll('source')).forEach(function (s) { s.parentNode.removeChild(s); });
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
    if (alt) img.alt = alt;
  }

  function apply(input, initial) {
    var scope = root(input, '[data-swatch-scope]');
    if (!scope) return;
    var d = input.dataset;

    var name = scope.querySelector('[data-swatch-name]');
    if (name && d.title) name.textContent = d.title;

    // Product pages with other options (e.g. Size): main-product resolves the full variant itself.
    if (scope.dataset.swatchScope === 'product' && scope.querySelector('[data-option-select]')) return;

    var img = scope.querySelector('[data-swatch-image], .product-card__frame img, .product-page__frame img');
    if (img && d.image && !initial) {
      var isPage = scope.dataset.swatchScope === 'product';
      var url = (isPage && d.imageLarge) ? d.imageLarge : d.image;
      var alt = d.alt || (d.title ? (img.dataset.baseAlt || img.alt).replace(/ in .*$/, '') + ' in ' + d.title : '');
      swapImage(img, url, alt);
    }

    var idInput = scope.querySelector('[data-variant-input]');
    if (idInput) idInput.value = d.variantId;

    var price = scope.querySelector('[data-swatch-price]');
    if (price && d.price) price.textContent = d.price;

    var add = scope.querySelector('[data-swatch-add]');
    var sold = scope.querySelector('[data-swatch-sold]');
    var available = d.available === 'true';
    if (add) {
      add.disabled = !available;
      if (add.dataset.labelAdd) {
        add.textContent = available ? add.dataset.labelAdd : (add.dataset.labelSold || 'Sold out');
      } else {
        add.hidden = !available;
      }
    }
    if (sold) sold.hidden = available;

    if (scope.dataset.swatchScope === 'product' && d.url) {
      try { history.replaceState({}, '', d.url); } catch (e) {}
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input && input.matches && input.matches('[data-swatch]')) apply(input);
  });

  document.querySelectorAll('[data-swatch-scope]').forEach(function (scope) {
    var inputs = Array.prototype.slice.call(scope.querySelectorAll('[data-swatch]'));
    if (!inputs.length) return;
    var checked = inputs.filter(function (i) { return i.checked; })[0];
    var changed = false;
    if (!checked || checked.dataset.available !== 'true') {
      var next = inputs.filter(function (i) { return i.dataset.available === 'true'; })[0];
      if (next) { next.checked = true; checked = next; changed = true; }
    }
    // Keep the server-rendered image unless the preselect moved to a different finish.
    if (checked) apply(checked, !changed);
  });
})();
